// extracted by mini-css-extract-plugin
module.exports = {"total":"styles_total__2Q8NX","messages":"styles_messages__o9IcF","order_info":"styles_order_info__1tnQV","submit":"styles_submit__11q2-"};